import { EventDispatcher, Object3D } from 'three';
import Beacon from './beacon';

// slider handles the creation and relationship of Beacons in the scene
// TODO should be renamed to BeaconManager or something
export default class Slider extends EventDispatcher {
  constructor(state, scene, camera, container) {
    super();
    this.state = state;
    this.camera = camera;
    this.container = container;

    this.obj = new Object3D();
    this.obj.name = 'beaconContainer';
    scene.add(this.obj);

    this.beaconCount = this.state.views.length;
    this.beaconOffset = 0.5;
    this.scrollSpeed = 0.005;
    this.beacons = this.initBeacons(scene);

    this.center = 3 * this.beaconOffset / 2;
    this.camera.position.x = this.center;

    this.onBeaconTabbed = this.onBeaconTabbed.bind(this);
    this.onBeaconUntabbed = this.onBeaconUntabbed.bind(this);
    this.onBeaconClick = this.onBeaconClick.bind(this);
    this.initBeacons = this.initBeacons.bind(this);
  }

  initEventListeners(tabDelegate) {
    tabDelegate.addEventListener('onBeaconTabbed', this.onBeaconTabbed);
    tabDelegate.addEventListener('onBeaconUntabbed', this.onBeaconUntabbed);
    tabDelegate.addEventListener('onBeaconEnterKeyUp', (event) => { this.onBeaconClick(event.beacon); });
  }

  initBeacons() {
    const beacons = {};

    this.state.views.forEach((view, index) => {
      if (!view.menuOnly) {
        const beacon = new Beacon(this.state, view, index);
         //beacon.obj.position.set(index * this.beaconOffset, 0.2, -1);

          

          const mq = window.matchMedia("(max-width: 1200px)");

          if (mq.matches) {
              beacon.obj.position.set(index * this.beaconOffset, 0.2, -0.3); 
             
          } else {
              beacon.obj.position.set(index * this.beaconOffset, 0.2, -1);

          }



        beacons[view.name] = beacon;
        this.obj.add(beacon.obj);
      }
    });
    return beacons; 
  }

  setBeaconsVisible(isVisible) {
    Object.keys(this.beacons).forEach((beacon) => {
      this.beacons[beacon].obj.visible = isVisible;
    });
    }




  onViewClose(view) {
    if (!(view in this.beacons)) return;

    // if view was opened through flying

    if (this.beacons[view] === this.selectedBeacon) {  
      this.selectedBeacon.close(() => {
          this.isViewing = false;

          let elements = document.querySelectorAll(".tab_" + view);
          var isValid = true;

          for (var i = 0; i < elements.length; i++) {
              if (!(elements[i].classList.contains("tab-visited"))) {
                  isValid = false;

              }
          }

          if (isValid) {
              this.selectedBeacon.setCheckmarkVisible();

              localStorage.setItem('visited-beacon', view);
              localStorage.setItem('tab_' + view , 'complete');
          }
           



      });
    }
    // else view was opened through the menu

    else {


        let elements = document.querySelectorAll(".tab_" + view);
      
        var isValid = true;

        for (var i = 0; i < elements.length; i++) {
            if (!(elements[i].classList.contains("tab-visited"))) {
                isValid = false;

            }
        }

        if (isValid) {
            this.beacons[view].setCheckmarkVisible();
            localStorage.setItem('visited-beacon', view);
            localStorage.setItem('tab_' + view, 'complete');

        }



    }
  }

  onBeaconEnter(beacon) {
    // todo: hack so that only one beacon is scaled up
    Object.keys(this.beacons).forEach((key) => {
      this.beacons[key].scaleDown();
    });

    this.beacons[beacon].scaleUp();
    document.body.style.cursor = 'pointer';
  }

  onBeaconExit(beacon) {
    this.beacons[beacon].scaleDown();
    document.body.style.cursor = 'default';
  }

  onBeaconClick(beacon) {
    if (this.state.view) return;
    this.selectedBeacon = this.beacons[beacon];
    this.selectedBeacon.select();
      this.isViewing = true;


      document.getElementById("tab_" + this.state.view + "_1").classList.add("tab-visited");
	  document.getElementById("menu_btn_" + this.state.view).classList.add("visited");


      ///// 

      var sounds = document.getElementsByTagName("audio");
      for (var i = 0; i < sounds.length; i++) {
          sounds[i].pause();
      }

      var playr1 = document.querySelector("#aud_tab_" + this.state.view + "_1");
 


      if (playr1) {

          /// start the audio, check for delay attribute 
          let d = 0, _this = this;
          if (playr1.getAttribute('delay')) {
              d = playr1.getAttribute('delay') * 1000;
          }

          /// settimeout delay (0 if no delay)

          setTimeout(function () {
              if (playr1) {

                  //console.log("audio found");
                  playr1.currentTime = 0;
                  playr1.play();
              }
          }, d);
      }



				/////



  } 

  onBeaconTabbed(args) {
    const beacon = args.beacon;
    if (this.beacons[beacon]) {
      this.beacons[beacon].scaleUp();
    }
  }

  onBeaconUntabbed(args) {
    const beacon = args.beacon;
    if (this.beacons[beacon]) {
      this.beacons[beacon].scaleDown();
    }
  }
}
